import {CustomerDTO} from './customerDTO.interface';
import {BaseIntDTO} from "./_baseIntDTO.interface";

export interface ProductDTO extends BaseIntDTO {
  productName?: string;
  productCode?: string;
  taxId?: number;
}
